import React from 'react';
import { Box, Text, LinearProgressBar, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { LoadingDots } from '../LoadingDots/LoadingDots';
import s from './ProgressSection.scss';
import { useViewport } from '../../../../../../context/viewport';

interface ProgressSectionProps {
  progress: number;
  currentStep: number;
  getStepText: (step: number) => string;
}

export const ProgressSection: React.FC<ProgressSectionProps> = ({ progress, currentStep, getStepText }) => {
  const { t } = useTranslation();
  const { isDesktop } = useViewport();

  return (
    <Box direction="vertical" gap={3} align="center" width="100%">
      <Heading size={isDesktop ? 'extraLarge' : 'small'} className={s.title}>
        {t('products.loader.title')}
      </Heading>

      <Text className={`${s.subtitle} ${isDesktop ? s.desktopText : ''}`}>{t('products.loader.subtitle')}</Text>

      <Box width="100%" maxWidth="600px" className={s.progressBarWrapper}>
        <LinearProgressBar value={progress} showProgressIndication />
      </Box>

      {progress < 100 && (
        <Box direction="vertical" align="center">
          <Text className={`${s.textSecondary} ${isDesktop ? s.desktopText : ''}`}>
            {t(getStepText(currentStep))}
          </Text>
          <LoadingDots />
        </Box>
      )}
    </Box>
  );
};
